
<template>
  <div class="app">
    <Headers></Headers>
    <div class="center">
      <div class="app_bg">
        <!-- <img src="https://aliyunosszs.musicwow.com/APPimg/app/app(6).png"> -->
        <img :src="bgUrl" @click="toApp()" />
      </div>
      <div class="app_body">
        <div class="body_live">
          <h3>丰富课程资源<br />助你快速打开学习音乐的闸门</h3>
          <P
            >吉他、尤克里里、钢琴、爵士鼓......<br />
            从入门基本功到大师级演出技巧一手掌握</P
          >
          <div class="showBg"></div>
          <div class="body_img">
            <img src="../assets/img/app/app-1.jpg" />
          </div>
        </div>
        <div class="body_type">
          <h3>多种课程学习方式<br />随时随地学习音乐</h3>
          <P
            >直播课、录播课、在线1V1陪练/名师约课<br />
            让音乐课程形式更多元化</P
          >
          <div class="showBg"></div>
          <div class="body_img">
            <img src="../assets/img/app/app-2.png" />
          </div>
        </div>
        <div class="body_party">
          <h3>优质讲师团队</h3>
          <P class="desp"
            >与华语乐坛著名吉他大师江建民、香港著名全能职业吉他手TOMMY、狮子lion团长&吉他手力Q等知名音乐人合作研发超级网络课，是以“APP网络教学+实体教材”为创新教育模式的大师系列超级课程。</P
          >
          <div class="showBg"></div>
          <img
            class="party_but"
            @click="onPartyData()"
            src="https://aliyunosszs.musicwow.com/APPimg/app/app(5).png"
          />
          <div class="body_img">
            <img src="../assets/img/app/app-3.jpg" />
          </div>
        </div>
        <div class="body_share">
          <h3>线下体验中心<br />沉浸式音乐学习环境及氛围</h3>
          <P
            >音乐窝致力于打造基于“普及音乐、启发思维、培养审美”<br />教学理念的音乐教育生态<br />在全国布局了多个线下门店体验中心、体验教室</P
          >
          <div class="showBg"></div>
          <!-- <img class="party_but" src="https://aliyunosszs.musicwow.com/APPimg/app/app(5).png"> -->
          <div class="body_img">
            <img src="../assets/img/app/app-4.png" />
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import VDistpicker from "v-distpicker";
export default {
  components: {
    Headers,
    Footer,
    VDistpicker,
  },
  name: "app",
  data() {
    return {
      bgUrl: "",
    };
  },
  methods: {
    async onBulist() {
      let bgData = await this.$API.getBgListData({});
      let listData = bgData.data;
      listData.forEach((item, index) => {
        switch (item.type) {
          case "app_bg_mobile":
            this.bgUrl = item.image;
            // console.log(item)
            break;
        }
      });
    },
    onPartyData() {
      location.href =
        "https://x.eqxiu.com/s/647hFkNp?eqrcode=1&share_level=2&from_user=2022021043d86afb&from_id=1ad737cc-a&share_time=1644472172949";
    },
    toApp() {
      location.href =
        "https://sj.qq.com/myapp/detail.htm?apkName=com.conwaysmusic.live";
    },
  },
  mounted() {
    this.onBulist();
  },
};
</script>
<style lang="scss" scoped>
.inherit {
  padding-top: 50px;
  h3 {
    font-size: 16px;
    color: #5c5c5c;
    font-weight: 600;
  }
  p {
    font-size: 10px;
    color: #909090;
    padding: 10px 0;
  }
  .showBg {
    background: #07d1aa;
    width: 34px;
    height: 3px;
    margin: 13px auto;
  }
  .body_img {
    width: 285px;
    margin: auto;
    height: 348px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.app {
  width: 100%;
  height: 100%;
  .center {
    padding-top: 60px;
  }
  .app_bg {
    width: 100%;
  }
  .app_body {
    .body_live {
      @extend .inherit;
      .body_img {
        width: 260px !important;
        height: auto !important;
      }
    }
    .body_type {
      // background: #F8F8F8;
      @extend .inherit;
      .body_img {
        width: 280px !important;
        height: auto !important;
      }
    }
    .body_party {
      @extend .inherit;
      .desp {
        padding: 12px 32px;
      }
      .party_but {
        width: 89px;
        height: 30px;
        margin: 10px 0;
      }
      .body_img {
        width: 254px !important;
        height: auto !important;
      }
    }
    .body_share {
      background: #f8f8f8;
      @extend .inherit;
      .body_img {
        width: 309px !important;
        height: auto !important;
      }
    }
  }
}
</style>

